import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject
export class User {

  @JsonProperty('firstName')
  private _firstName: string;
  @JsonProperty('lastName')
  private _lastName: string;
  @JsonProperty('role')
  private _role: string;
  @JsonProperty('emailAddress')
  private _emailAddress: string;
  @JsonProperty('company')
  private _company: string;
  @JsonProperty('password')
  private _password: string;
  @JsonProperty('confirmPassword')
  private _confirmPassword: string;
  @JsonProperty('agreed')
  private _agreed = false;

  get firstName(): string {
    return this._firstName;
  }

  set firstName(value: string) {
    this._firstName = value;
  }

  get lastName(): string {
    return this._lastName;
  }

  set lastName(value: string) {
    this._lastName = value;
  }

  get role(): string {
    return this._role;
  }

  set role(value: string) {
    this._role = value;
  }

  get emailAddress(): string {
    return this._emailAddress;
  }

  set emailAddress(value: string) {
    this._emailAddress = value;
  }

  get company(): string {
    return this._company;
  }

  set company(value: string) {
    this._company = value;
  }

  get password(): string {
    return this._password;
  }

  set password(value: string) {
    this._password = value;
  }

  get confirmPassword(): string {
    return this._confirmPassword;
  }

  get agreed(): boolean {
    return this._agreed;
  }

  set agreed(value: boolean) {
    this._agreed = value;
  }

  set confirmPassword(value: string) {
    this._confirmPassword = value;
  }
}
